// import React, { PureComponent } from 'react';
import { useTheme } from '@material-ui/core';
import { PieChart, Pie, Sector } from 'recharts';
import { percentFormatter } from '../utils/formatters';

interface CircleProps {
  percent: number;
}

const Circle = (props: CircleProps) => {
  const theme = useTheme();

  const { percent } = props

  const data = [
    { name: 'filled', value: percent, fill: theme.palette.primary.light, stroke: '' },
    { name: 'unfilled', value: 1 - percent, fill: theme.palette.background.default, stroke: '' },
  ]

  const PieLabel = (props: any) => {

    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, percent } = props;

    return (
      <g>
        <text
          x={cx}
          y={cy}
          dy={5}
          style={{ fontWeight: 'bold', fontSize: '12px' }}
          textAnchor="middle"
          fill={theme.palette.text.primary}
        >
          {percentFormatter('en', { maximumFractionDigits: 0 }).format(percent)}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    );
  };


  return <PieChart width={60} height={60}>
    <Pie
      data={data}
      dataKey="value"
      nameKey="name"
      cx="50%"
      cy="50%"
      innerRadius={24}
      outerRadius={30}
      activeShape={PieLabel}
      activeIndex={0}
    >
      {/* {data.map((entry, index) => ( */}
      {/* <Cell key={`cell-${1}`} fill={data[0].fill} /> */}
      {/* ))} */}
    </Pie>
  </PieChart>
}


export default Circle